import React from "react";

function AssentTekenizationHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Tokenize Real-World Assets for a Future-Proof Financial
                  Ecosystem
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Unlock liquidity, transparency, and fractional ownership
                    with our asset tokenization services.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AssentTekenizationHero;
